var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { Tabs, Tab, Typography } from '@material-ui/core';
import MultilineChartIcon from '@material-ui/icons/MultilineChart';
import TimelineIcon from '@material-ui/icons/Timeline';
import BarChartIcon from '@material-ui/icons/BarChart';
import PieChartIcon from '@material-ui/icons/PieChart';
import GridOnIcon from '@material-ui/icons/GridOn';
import { BarChartSchema, LiftChartSchema, LineChartSchema, PieChartSchema, TableChartSchema, } from '../../../entities';
import theme from '../../theme';
var chartSchemas = [LiftChartSchema, LineChartSchema, BarChartSchema, PieChartSchema, TableChartSchema];
var ChartSelector = function (_a) {
    var setChartSchema = _a.setChartSchema;
    var _b = React.useState('COMBINATION'), chartType = _b[0], setChartType = _b[1];
    var handleChange = function (event, newValue) {
        setChartType(newValue);
        setChartSchema(chartSchemas.filter(function (schema) {
            return schema.type === newValue;
        })[0]);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ChartTabs, { value: chartType, onChange: handleChange, variant: "fullWidth", indicatorColor: "secondary", textColor: "secondary", "aria-label": "graph-selector" },
            React.createElement(ChartTab, { icon: React.createElement(MultilineChartIcon, null), "aria-label": "lift", value: "COMBINATION" }),
            React.createElement(ChartTab, { icon: React.createElement(TimelineIcon, null), "aria-label": "line", value: "LINE" }),
            React.createElement(ChartTab, { icon: React.createElement(BarChartIcon, null), "aria-label": "bar", value: "BAR" }),
            React.createElement(ChartTab, { icon: React.createElement(PieChartIcon, null), "aria-label": "pie", value: "PIE" }),
            React.createElement(ChartTab, { icon: React.createElement(GridOnIcon, null), "aria-label": "table", value: "TABLE" })),
        React.createElement(SelectedChartType, { chartType: chartType })));
};
var ChartTabs = withStyles({
    root: {
        flexGrow: 1,
        minWidth: 300,
        '& .MuiTab-root': {
            minWidth: 30,
        },
    },
    indicator: {
        display: 'none',
    },
})(Tabs);
var ChartTab = withStyles({
    textColorSecondary: {
        '&.Mui-selected': {
            color: theme.palette.highlight.main,
        },
    },
})(Tab);
var ShownChartStyles = makeStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        marginTop: 10,
        textAlign: 'center',
    },
    icon: {
        color: theme.palette.primary.main,
        fontSize: 150,
        margin: 20,
    },
    explanation: {
        margin: '0 12px 24px',
    },
});
var SelectedChartType = function (_a) {
    var _b = _a.chartType, chartType = _b === void 0 ? 'LIFT' : _b, props = __rest(_a, ["chartType"]);
    var classes = ShownChartStyles();
    switch (chartType) {
        case 'COMBINATION':
            return (React.createElement("div", { className: classes.root },
                React.createElement(Typography, { variant: "h6" }, "Lift Report"),
                React.createElement(MultilineChartIcon, { className: classes.icon, color: "primary" }),
                React.createElement(Typography, { className: classes.explanation, variant: "body2" }, "This graph compares multiple sequencial data which usually shares the same timeline")));
        case 'LINE':
            return (React.createElement("div", { className: classes.root },
                React.createElement(Typography, { variant: "h6" }, "Timeline Chart"),
                React.createElement(TimelineIcon, { className: classes.icon, color: "primary" }),
                React.createElement(Typography, { className: classes.explanation, variant: "body2" }, "A simple line graph to visualize sequential changes")));
        case 'BAR':
            return (React.createElement("div", { className: classes.root },
                React.createElement(Typography, { variant: "h6" }, "Bar Chart"),
                React.createElement(BarChartIcon, { className: classes.icon, color: "primary" }),
                React.createElement(Typography, { className: classes.explanation, variant: "body2" }, "A simple bar graph to visualize relative sizes of the data")));
        case 'PIE':
            return (React.createElement("div", { className: classes.root },
                React.createElement(Typography, { variant: "h6" }, "Pie Chart"),
                React.createElement(PieChartIcon, { className: classes.icon, color: "primary" }),
                React.createElement(Typography, { className: classes.explanation, variant: "body2" }, "A simple pie graph to visualize ratios of the data")));
        case 'TABLE':
            return (React.createElement("div", { className: classes.root },
                React.createElement(Typography, { variant: "h6" }, "Table Chart"),
                React.createElement(GridOnIcon, { className: classes.icon, color: "primary" }),
                React.createElement(Typography, { className: classes.explanation, variant: "body2" }, "A table to show selected columns of the data")));
        default:
            return React.createElement("div", null, "please select a chart type...");
    }
};
export default ChartSelector;
